import { z } from 'zod';
import { idSchema } from './common.js';
/** Adresse normalisée : espaces retirés, minuscules. C'est cette forme qui est stockée et comparée. */
export const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));
/** Code TOTP à six chiffres, tel que l'affiche l'application d'authentification. */
export const totpCodeSchema = z.string().regex(/^\d{6}$/, 'Six chiffres');
export const loginInputSchema = z.object({
    email: emailSchema,
    // Aucune règle de composition à la connexion : elles s'appliquent à la création du mot de passe.
    // Le plafond évite qu'un corps démesuré n'occupe un calcul argon2.
    password: z.string().min(1).max(1024),
    /** Exigé seulement si le compte a activé la double authentification. */
    totpCode: totpCodeSchema.optional(),
});
export const sessionUserSchema = z.object({
    id: idSchema,
    email: z.string(),
    totpEnabled: z.boolean(),
});
export const totpSetupSchema = z.object({
    /** Secret en base32, à saisir à la main si le QR code n'est pas possible. */
    secret: z.string(),
    /** `otpauth://…` : ce que le front encode en QR code. */
    otpauthUri: z.string(),
});
/**
 * Préparer la double authentification exige le mot de passe : sans cela, une session dérobée
 * pourrait y enrôler son propre appareil et enfermer dehors le propriétaire du compte.
 */
export const totpSetupInputSchema = z.object({ password: z.string().min(1).max(1024) });
export const totpEnableInputSchema = z.object({ code: totpCodeSchema });
/** Désactiver la double authentification exige de prouver qui l'on est, une seconde fois. */
export const totpDisableInputSchema = z.object({
    password: z.string().min(1).max(1024),
    code: totpCodeSchema,
});
/** Longueur minimale d'un mot de passe, appliquée à la création (ligne de commande). */
export const MIN_PASSWORD_LENGTH = 12;
//# sourceMappingURL=auth.js.map